import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

function isFormDataPayload(value) {
  return typeof FormData !== 'undefined' && value instanceof FormData;
}

function clearContentType(headers) {
  if (!headers) return;
  if (typeof headers.set === 'function') {
    headers.set('Content-Type', null);
    return;
  }
  delete headers['Content-Type'];
  delete headers['content-type'];
}

// Attach JWT to EVERY request
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (isFormDataPayload(config.data)) {
    clearContentType(config.headers);
  }

  // Prevent caching on GET
  if (config.method === 'get') {
    config.headers['Cache-Control'] = 'no-cache';
    config.headers['Pragma'] = 'no-cache';
    config.headers['Expires'] = '0';
  }

  return config;
});

export default axiosInstance;
